/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandingOptions,
    BrandingOptionsFromJSON,
    BrandingOptionsFromJSONTyped,
    BrandingOptionsToJSON,
    DefinitionOptions,
    DefinitionOptionsFromJSON,
    DefinitionOptionsFromJSONTyped,
    DefinitionOptionsToJSON,
    DocumentOverride,
    DocumentOverrideFromJSON,
    DocumentOverrideFromJSONTyped,
    DocumentOverrideToJSON,
    FirmNameStyle,
    FirmNameStyleFromJSON,
    FirmNameStyleFromJSONTyped,
    FirmNameStyleToJSON,
    Margins,
    MarginsFromJSON,
    MarginsFromJSONTyped,
    MarginsToJSON,
    PropoundingFormatOptions,
    PropoundingFormatOptionsFromJSON,
    PropoundingFormatOptionsFromJSONTyped,
    PropoundingFormatOptionsToJSON,
    ReplacementOptions,
    ReplacementOptionsFromJSON,
    ReplacementOptionsFromJSONTyped,
    ReplacementOptionsToJSON,
    RequestOptions,
    RequestOptionsFromJSON,
    RequestOptionsFromJSONTyped,
    RequestOptionsToJSON,
    ResponseOptions,
    ResponseOptionsFromJSON,
    ResponseOptionsFromJSONTyped,
    ResponseOptionsToJSON,
    RulesOptions,
    RulesOptionsFromJSON,
    RulesOptionsFromJSONTyped,
    RulesOptionsToJSON,
    SupplementalResponseHeaderStyle,
    SupplementalResponseHeaderStyleFromJSON,
    SupplementalResponseHeaderStyleFromJSONTyped,
    SupplementalResponseHeaderStyleToJSON,
} from './';

/**
 * 
 * @export
 * @interface DocumentPreferences
 */
export interface DocumentPreferences {
    /**
     * 
     * @type {Margins}
     * @memberof DocumentPreferences
     */
    margins?: Margins;
    /**
     * 
     * @type {number}
     * @memberof DocumentPreferences
     */
    linesPerPage?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof DocumentPreferences
     */
    useVsInsteadOfV?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DocumentPreferences
     */
    boldAttorneyNames?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof DocumentPreferences
     */
    fontSize?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentPreferences
     */
    fontType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentPreferences
     */
    footerText?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DocumentPreferences
     */
    footerFontSize?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DocumentPreferences
     */
    firmNameFontSize?: number | null;
    /**
     * 
     * @type {FirmNameStyle}
     * @memberof DocumentPreferences
     */
    firmNameStyle?: FirmNameStyle;
    /**
     * 
     * @type {boolean}
     * @memberof DocumentPreferences
     */
    deptInCaption?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DocumentPreferences
     */
    hideRequestsInResponses?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DocumentPreferences
     */
    hideDefinitionsInRequests?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DocumentPreferences
     */
    useSimpleRequestResponseStyle?: boolean | null;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof DocumentPreferences
     */
    documentTemplates?: { [key: string]: string; } | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentPreferences
     */
    leftLogo?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DocumentPreferences
     */
    addAnswerPromptAfterInterrogatories?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DocumentPreferences
     */
    alwaysShowDefinitionsInRequests?: boolean | null;
    /**
     * 
     * @type {SupplementalResponseHeaderStyle}
     * @memberof DocumentPreferences
     */
    supplementalResponseHeaderStyle?: SupplementalResponseHeaderStyle;
    /**
     * 
     * @type {boolean}
     * @memberof DocumentPreferences
     */
    excludeProofOfService?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof DocumentPreferences
     */
    leftLogoMarginOffset?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof DocumentPreferences
     */
    useAutoLineSpacing?: boolean | null;
    /**
     * 
     * @type {RequestOptions}
     * @memberof DocumentPreferences
     */
    _requestOptions?: RequestOptions;
    /**
     * 
     * @type {RulesOptions}
     * @memberof DocumentPreferences
     */
    rulesOptions?: RulesOptions;
    /**
     * 
     * @type {PropoundingFormatOptions}
     * @memberof DocumentPreferences
     */
    propoundingFormatOptions?: PropoundingFormatOptions;
    /**
     * 
     * @type {{ [key: string]: DocumentOverride; }}
     * @memberof DocumentPreferences
     */
    documentOverrides?: { [key: string]: DocumentOverride; } | null;
    /**
     * 
     * @type {DefinitionOptions}
     * @memberof DocumentPreferences
     */
    definitionOptions?: DefinitionOptions;
    /**
     * 
     * @type {ReplacementOptions}
     * @memberof DocumentPreferences
     */
    replacementOptions?: ReplacementOptions;
    /**
     * 
     * @type {ResponseOptions}
     * @memberof DocumentPreferences
     */
    responseOptions?: ResponseOptions;
    /**
     * 
     * @type {BrandingOptions}
     * @memberof DocumentPreferences
     */
    brandingOptions?: BrandingOptions;
}

export function DocumentPreferencesFromJSON(json: any): DocumentPreferences {
    return DocumentPreferencesFromJSONTyped(json, false);
}

export function DocumentPreferencesFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentPreferences {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'margins': !exists(json, 'margins') ? undefined : MarginsFromJSON(json['margins']),
        'linesPerPage': !exists(json, 'linesPerPage') ? undefined : json['linesPerPage'],
        'useVsInsteadOfV': !exists(json, 'useVsInsteadOfV') ? undefined : json['useVsInsteadOfV'],
        'boldAttorneyNames': !exists(json, 'boldAttorneyNames') ? undefined : json['boldAttorneyNames'],
        'fontSize': !exists(json, 'fontSize') ? undefined : json['fontSize'],
        'fontType': !exists(json, 'fontType') ? undefined : json['fontType'],
        'footerText': !exists(json, 'footerText') ? undefined : json['footerText'],
        'footerFontSize': !exists(json, 'footerFontSize') ? undefined : json['footerFontSize'],
        'firmNameFontSize': !exists(json, 'firmNameFontSize') ? undefined : json['firmNameFontSize'],
        'firmNameStyle': !exists(json, 'firmNameStyle') ? undefined : FirmNameStyleFromJSON(json['firmNameStyle']),
        'deptInCaption': !exists(json, 'deptInCaption') ? undefined : json['deptInCaption'],
        'hideRequestsInResponses': !exists(json, 'hideRequestsInResponses') ? undefined : json['hideRequestsInResponses'],
        'hideDefinitionsInRequests': !exists(json, 'hideDefinitionsInRequests') ? undefined : json['hideDefinitionsInRequests'],
        'useSimpleRequestResponseStyle': !exists(json, 'useSimpleRequestResponseStyle') ? undefined : json['useSimpleRequestResponseStyle'],
        'documentTemplates': !exists(json, 'documentTemplates') ? undefined : json['documentTemplates'],
        'leftLogo': !exists(json, 'leftLogo') ? undefined : json['leftLogo'],
        'addAnswerPromptAfterInterrogatories': !exists(json, 'addAnswerPromptAfterInterrogatories') ? undefined : json['addAnswerPromptAfterInterrogatories'],
        'alwaysShowDefinitionsInRequests': !exists(json, 'alwaysShowDefinitionsInRequests') ? undefined : json['alwaysShowDefinitionsInRequests'],
        'supplementalResponseHeaderStyle': !exists(json, 'supplementalResponseHeaderStyle') ? undefined : SupplementalResponseHeaderStyleFromJSON(json['supplementalResponseHeaderStyle']),
        'excludeProofOfService': !exists(json, 'excludeProofOfService') ? undefined : json['excludeProofOfService'],
        'leftLogoMarginOffset': !exists(json, 'leftLogoMarginOffset') ? undefined : json['leftLogoMarginOffset'],
        'useAutoLineSpacing': !exists(json, 'useAutoLineSpacing') ? undefined : json['useAutoLineSpacing'],
        '_requestOptions': !exists(json, 'requestOptions') ? undefined : RequestOptionsFromJSON(json['requestOptions']),
        'rulesOptions': !exists(json, 'rulesOptions') ? undefined : RulesOptionsFromJSON(json['rulesOptions']),
        'propoundingFormatOptions': !exists(json, 'propoundingFormatOptions') ? undefined : PropoundingFormatOptionsFromJSON(json['propoundingFormatOptions']),
        'documentOverrides': !exists(json, 'documentOverrides') ? undefined : (json['documentOverrides'] === null ? null : mapValues(json['documentOverrides'], DocumentOverrideFromJSON)),
        'definitionOptions': !exists(json, 'definitionOptions') ? undefined : DefinitionOptionsFromJSON(json['definitionOptions']),
        'replacementOptions': !exists(json, 'replacementOptions') ? undefined : ReplacementOptionsFromJSON(json['replacementOptions']),
        'responseOptions': !exists(json, 'responseOptions') ? undefined : ResponseOptionsFromJSON(json['responseOptions']),
        'brandingOptions': !exists(json, 'brandingOptions') ? undefined : BrandingOptionsFromJSON(json['brandingOptions']),
    };
}

export function DocumentPreferencesToJSON(value?: DocumentPreferences | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'margins': MarginsToJSON(value.margins),
        'linesPerPage': value.linesPerPage,
        'useVsInsteadOfV': value.useVsInsteadOfV,
        'boldAttorneyNames': value.boldAttorneyNames,
        'fontSize': value.fontSize,
        'fontType': value.fontType,
        'footerText': value.footerText,
        'footerFontSize': value.footerFontSize,
        'firmNameFontSize': value.firmNameFontSize,
        'firmNameStyle': FirmNameStyleToJSON(value.firmNameStyle),
        'deptInCaption': value.deptInCaption,
        'hideRequestsInResponses': value.hideRequestsInResponses,
        'hideDefinitionsInRequests': value.hideDefinitionsInRequests,
        'useSimpleRequestResponseStyle': value.useSimpleRequestResponseStyle,
        'documentTemplates': value.documentTemplates,
        'leftLogo': value.leftLogo,
        'addAnswerPromptAfterInterrogatories': value.addAnswerPromptAfterInterrogatories,
        'alwaysShowDefinitionsInRequests': value.alwaysShowDefinitionsInRequests,
        'supplementalResponseHeaderStyle': SupplementalResponseHeaderStyleToJSON(value.supplementalResponseHeaderStyle),
        'excludeProofOfService': value.excludeProofOfService,
        'leftLogoMarginOffset': value.leftLogoMarginOffset,
        'useAutoLineSpacing': value.useAutoLineSpacing,
        'requestOptions': RequestOptionsToJSON(value._requestOptions),
        'rulesOptions': RulesOptionsToJSON(value.rulesOptions),
        'propoundingFormatOptions': PropoundingFormatOptionsToJSON(value.propoundingFormatOptions),
        'documentOverrides': value.documentOverrides === undefined ? undefined : (value.documentOverrides === null ? null : mapValues(value.documentOverrides, DocumentOverrideToJSON)),
        'definitionOptions': DefinitionOptionsToJSON(value.definitionOptions),
        'replacementOptions': ReplacementOptionsToJSON(value.replacementOptions),
        'responseOptions': ResponseOptionsToJSON(value.responseOptions),
        'brandingOptions': BrandingOptionsToJSON(value.brandingOptions),
    };
}


